import React, { useState, useEffect } from "react";
import uuid from "react-uuid";
import { Formik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import MyTextInput from "../../../common/form/MyTextInput";
import MyDateInput from "../../../common/form/MyDateInput";

import {
  problemOptions,
  actionOptions,
} from "../../../../services/complaint.data";
import {
  Checkbox,
  Form,
  Segment,
  Button,
  Radio,
  List,
  Label,
  Message,
  Grid,
  Dropdown,
} from "semantic-ui-react";

const ConformiteAdd1 = ({ next, userList }) => {
  const { userEmail } = useSelector((state) => state.authReducer);

  const [listUsers, setLlistUsers] = useState([]);

  useEffect(() => {
    if (userList && userList.userByUserType && userList.userByUserType.items) {
      setLlistUsers(userList.userByUserType.items);
    }
  }, [userList]);

  const listtemp = listUsers.map((item) => {
    const container = {};
    container.key = item.name;
    container.value = item.name;
    container.text = item.name;
    container.icon = "user";
    return container;
  });

  const getQseId = () => {
    var currentDate = new Date();
    var formatDate = currentDate.toISOString().slice(0, 7).replace("-", "");
    var processus = uuid();
    return processus + "-" + formatDate + "-" + Date.now();
  };

  const getDisplayName = () => {
    return userEmail;
  };

  // setQseId(getQseId());

  const initialValues = {
    ownerProcess: "",
    autreSource: "",
    laquelle: "",
    qseId: getQseId(),
  };

  const validationSchema = Yup.object().shape({});

  const handleSubmit = (values) => {
    //
    let actions = [];
    for (const action of listAction) {
      actions.push(action);
    }

    //
    let problems = [];
    for (const problem of listProblem) {
      problems.push(problem);
    }

    values.createdAt = Date.now();
    values.emetteur = getDisplayName();
    values.listAction = actions;
    values.listProblem = problems;
    values.ownerProcess = ownerProcess;
    values.responsable = responsable;
    values.correction = correction;
    values.constat = constat;
    values.facteur = facteur;
    values.userId = userEmail;

    // alert(JSON.stringify(values, null, 2));
    //console.log(JSON.stringify(values, null, 2));

    next();
  };

  // Select field setting
  const [ownerProcess, setOwnerProcess] = useState(null);
  const handleOwnerProcess = (e, { value }) => setOwnerProcess(value);

  // Select field setting
  const [responsable, setResponsable] = useState(null);
  const handleResponsable = (e, { value }) => setResponsable(value);

  const [constat, setConstat] = useState("");
  const handleTextAreaConstat = (event) => {
    setConstat(event.target.value);
  };

  const [facteur, setFacteur] = useState("");
  const handleTextAreaFacteur = (event) => {
    setFacteur(event.target.value);
  };

  //
  const [isCorrection, setIsCorrection] = useState(false);
  const [correction, setCorrection] = useState("Non");
  const handleChangeCorrection = (event, { value }) => {
    setCorrection(value);
    if ("Oui" === correction) {
      setIsCorrection(false);
    } else {
      setIsCorrection(true);
    }
  };

  // Checkbox field setting
  const [isNonConformite, setIsNonConformite] = useState(false);
  const [listAction, setListAction] = useState(new Set());
  const handleAction = (event, { value }) => {
    if (listAction.has(value)) {
      listAction.delete(value);
    } else {
      listAction.add(value);
    }
    setListAction(listAction);

    if (listAction.has("NC (Non-conformité)")) {
      setIsNonConformite(true);
    } else {
      setIsNonConformite(false);
    }
  };

  // Checkbox field setting
  const [isOther, setIsOther] = useState(false);
  const [listProblem, setListProblem] = useState(new Set());
  const handleProblem = (event, { value }) => {
    if (listProblem.has(value)) {
      listProblem.delete(value);
    } else {
      listProblem.add(value);
    }
    setListProblem(listProblem);

    if (listProblem.has("Autres")) {
      setIsOther(!isOther);
    } else {
      setIsOther(false);
    }
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          <Form size="large" onSubmit={handleSubmit}>
            <Segment.Group>
              <Segment color="blue">
                <Label as="a" color="blue" ribbon>
                  Description
                </Label>
                <Grid columns="equal">
                  <Grid.Row>
                    <Grid.Column>
                      <Segment>
                        <span>{values.qse}</span>
                        <Message
                          info
                          attached
                          header="Numéro de fiche:"
                          content={values.qseId}
                        />
                      </Segment>
                    </Grid.Column>
                    <Grid.Column>
                      <Segment>
                        <Message
                          info
                          attached
                          header="Emetteur:"
                          content={getDisplayName()}
                        />
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Form.Group widths="equal">
                  <MyDateInput
                    label="Date de détection"
                    name="dateDetection"
                    placeholderText="Date de détection"
                    timeFormat="HH:mm"
                    showTimeSelect
                    timeCaption="time"
                    dateFormat="MMMM d, yyyy h:mm a"
                    autoComplete="off"
                  />
                  <Form.Field>
                    <b>Processus propriétaire</b>
                    <Dropdown
                      placeholder="Processus propriétaire"
                      name="responsable"
                      fluid
                      selection
                      options={listtemp}
                      onChange={handleOwnerProcess}
                      value={ownerProcess}
                    />
                  </Form.Field>
                </Form.Group>
                <Form.Group inline>
                  <label>Type:</label>

                  {actionOptions.map((action) => (
                    <List.Item key={action.value}>
                      <List.Content>
                        <Form.Field
                          control={Checkbox}
                          label={action.value}
                          value={action.value}
                          onChange={handleAction}
                        />
                      </List.Content>
                    </List.Item>
                  ))}
                </Form.Group>
              </Segment>
              {isNonConformite && (
                <Segment color="blue">
                  <Label as="a" color="blue" ribbon>
                    Causes et facteurs de risques
                  </Label>
                  <List divided relaxed>
                    <List.Item>
                      <List.Content>
                        <List.Description>
                          <Form.TextArea
                            name="facteur"
                            placeholder="Causes et facteurs de risques"
                            rows={3}
                            onChange={handleTextAreaFacteur}
                          ></Form.TextArea>
                        </List.Description>
                      </List.Content>
                    </List.Item>
                  </List>
                </Segment>
              )}
              <Segment color="blue">
                <Label as="a" color="blue" ribbon>
                  Sources des problèmes
                </Label>
                <List>
                  {problemOptions.map((problem) => (
                    <List.Item key={problem.value}>
                      <List.Content>
                        <Form.Field
                          control={Checkbox}
                          label={problem.value}
                          value={problem.value}
                          onChange={handleProblem}
                        />
                      </List.Content>
                    </List.Item>
                  ))}
                </List>
              </Segment>
              {isOther && (
                <Form.Group inline>
                  <label>Description rubrique autre source:</label>
                  <MyTextInput name="autreSource" placeholder="Autre source" />
                </Form.Group>
              )}

              <Segment color="blue">
                <Label as="a" color="blue" ribbon>
                  Description des constats, Situation indésirable et Résultats
                  des analyses
                </Label>
                <List divided relaxed>
                  <List.Item>
                    <List.Content>
                      <List.Description>
                        <Form.TextArea
                          name="constat"
                          placeholder="Description des constats, Situation indésirable et Résultats des analyses"
                          rows={5}
                          onChange={handleTextAreaConstat}
                        ></Form.TextArea>
                      </List.Description>
                    </List.Content>
                  </List.Item>
                </List>
              </Segment>
              <Segment>
                <Form.Group inline>
                  <label> Action immédiate (correction):</label>
                  <Form.Field
                    control={Radio}
                    name="correction"
                    label="Non"
                    value="Non"
                    onChange={handleChangeCorrection}
                    checked={"Non" === correction}
                  />
                  <Form.Field
                    control={Radio}
                    name="correction"
                    label="Oui"
                    value="Oui"
                    onChange={handleChangeCorrection}
                    checked={"Oui" === correction}
                  />
                  {isCorrection && (
                    <>
                      <label> Laquelle ?:</label>
                      <MyTextInput name="laquelle" />
                    </>
                  )}
                </Form.Group>
                <Form.Group widths="equal">
                  <MyDateInput
                    label="Date"
                    name="dateQse"
                    placeholderText="Date"
                    timeFormat="HH:mm"
                    showTimeSelect
                    timeCaption="time"
                    dateFormat="MMMM d, yyyy h:mm a"
                    autoComplete="off"
                  />
                  <Form.Field>
                    <b>Réalisé par (nom et visas)</b>
                    <Dropdown
                      placeholder="Responsable traitements"
                      name="responsable"
                      fluid
                      selection
                      options={listtemp}
                      onChange={handleResponsable}
                      value={responsable}
                    />
                  </Form.Field>
                </Form.Group>
              </Segment>

              <Segment textAlign="center">
                <Button.Group>
                  <Button
                    fluid
                    type="submit"
                    floated="right"
                    positive
                    content="Suivant"
                  />
                </Button.Group>
              </Segment>
            </Segment.Group>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ConformiteAdd1;
